import { createEnum } from '@luna/utils-ts';

export const ExternalProductType = createEnum(
    'BUILDINGSOCIETY',
    'SECURITY',
    'INSURANCE',
    'LEASING',
    'PENSION',
    'EXTBANK',
);
export type ExternalProductType = createEnum<typeof ExternalProductType>;
